export enum EscrowOrderManageAction {
  Cancel = 'cancel',
  ExtendShippingDeadline = 'extend_shipping_deadline',
  ChangeDeliveryOption = 'change_delivery_option',
}

export enum EscrowOrderStatus {
  Created = 'created',
  ReadyToBeShiped = 'ready_to_be_shipped',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Lost = 'lost',
  ReturnRequested = 'return_requested',
  ReturnInitiated = 'return_initiated',
  ReturnShipped = 'return_shipped',
  ReturnDelivered = 'return_delivered',
  ReturnLost = 'return_lost',
  Canceled = 'canceled',
  Completed = 'completed',
  CompletedPartially = 'completed_partially',
  Closed = 'closed',
}

export enum EscrowOrderDisplayGroup {
  Sale = 10,
  Shipment = 20,
  Delivery = 25,
  OrderComplaint = 26,
  ReturnShipment = 27,
  Completion = 40,
  PartialCompletion = 43,
  Refund = 45,
}

export enum EscrowOrderEventSource {
  Order = 'order',
  Fulfillment = 'fulfillment',
  Complaints = 'complaints',
}

export enum EscrowOrderDetailsClickTarget {
  ShowEscrowOrderDetails = 'show_escrow_order_details',
  ItemInfo = 'item_information',
  ShippingInstructions = 'shipping_instructions',
  NearestDropOffPoints = 'nearest_drop_off_points',
  TrackingInfo = 'tracking_information',
  Message = 'message',
  ManageOrder = 'manage_order',
  Help = 'help',
  Profile = 'profile',
  LearnMoreCurrencyConversion = 'learn_more_currency_conversion',
  ExtendShippingDeadline = 'extend_shipping_deadline',
  ChangeDeliveryOption = 'change_delivery_option',
  CancelOrder = 'cancel_order',
}

export enum EscrowOrderActionType {
  // event_source: fulfillment
  GetShippingLabel = 'get_shipping_label',
  UntrackedShipment = 'untracked_shipping_instructions',
  CustomShipment = 'custom_shipping_instructions',
  OpenQrCode = 'open_qr_code',
  ViewDeliveryInstructions = 'view_delivery_instructions',
  DownloadShippingLabel = 'download_shipping_label',
  MarkAsShipped = 'mark_as_shipped',
  MarkAsDelivered = 'mark_as_delivered',
  CancellationConfirm = 'cancellation_confirm',
  CancellationDecline = 'cancellation_decline',
  TrackShipment = 'track_shipment',
  WeHaveMet = 'we_have_met',
  CancelShippingDeadlineExtension = 'cancel_shipping_deadline_extension',
  AgreeExtendShippingDeadline = 'agree_extend_shipping_deadline',
  DeclineShippingDeadlineExtension = 'decline_shipping_deadline_extension',
  CancelChangeDeliveryOptionRequest = 'cancel_change_delivery_option_request',
  AcceptChangeHomeDeliveryOptionRequest = 'accept_change_home_delivery_option_request',
  AcceptChangePickupDeliveryOptionRequest = 'accept_change_pickup_delivery_option_request',
  ExtendShippingDeadline = 'extend_shipping_deadline', // double check with backend
  MarkAsReturnedToSender = 'complete_return_to_sender',
  // event_source: complaints
  ResolveComplaint = 'resolve_complaint',
  ViewComplaint = 'view_complaint',
  ViewIssueDetails = 'view_issue_details',
  RequestReturn = 'request_to_return',
  ReturnOrder = 'return_order',
  CancelRefundOffer = 'cancel_refund_offer',
  AcceptRefundOffer = 'accept_refund_offer',
  RejectRefundOffer = 'reject_refund_offer',
  ChooseResolution = 'choose_resolution',
  // event_source: order
  ReportProblem = 'i_have_issues',
  ReuploadItem = 'reupload',
  GoToWallet = 'goto_wallet',
  CompleteTransaction = 'all_is_good',
  CompleteDeliveredTransaction = 'all_is_good_delivered',
  LeaveFeedback = 'leave_feedback',
  RefundProgress = 'refund_progress',
  ActivateBalance = 'activate_balance',
  UploadItem = 'upload_item',
}

export enum EscrowOrderLinkAction {
  ShipmentTrackingLink = 'react-shipment-tracking-link',
  BuyerDetailsLink = 'buyer-details-link',
  OfflineVerificationInfoLink = 'react-offline-verification-info-link',
  DropOffPointMapLink = 'react-drop-off-point-map-link',
  ElectronicsVerificationInfoLink = 'react-electronics-verification-info-link',
  PickUpParcelLink = 'react-pickup-parcel-link',
}

export enum EscrowOrderTrackingEntrySource {
  Conversation = 'conversation',
  Inbox = 'inbox',
  Purchase = 'purchase',
  Email = 'email',
  MyOrders = 'my_orders',
  Other = 'other',
}
